// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"7346ee38","455":"086a13a7","644":"705cda48"}[chunkId] + ".chunk.js";
};